<ngb-timepicker [spinners]="false" [readonlyInputs]="disabled" [(ngModel)]="time" (ngModelChange)="setValue()" [meridian]="false"></ngb-timepicker>